
<template>
  <div>
    <draggable 
      v-model="local_groups" 
      v-bind="dragOptions" 
      group="group" 
      @change="reorder" 
      @start="handleDragStart" 
      @end="handleDragStop" 
      :draggable="one_flow.status == 'draft'? '.bacon' : '.nada'" 
      :handle="one_flow.status == 'draft'? '.handle' : '.nada'"
    >
      <transition-group 
        type="transition" 
        :name="!is_dragging ? 'flip-list' : null"
      >
        <div v-for="(group, idx) in local_groups" :key="group.id" class="bacon handle">
          <group-card    
            :group="group" 
            class="mb-3"
          ></group-card>
        </div>
      </transition-group>
    </draggable>
    <dialog-loading
      v-if="loading"
      loadingText="Reordenando"
    ></dialog-loading>
    <!-- {{ local_groups }} -->
    
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import draggable_helpers from '@/mixins/draggable_helpers'

export default {
  name: "GroupList",
  mixins: [ draggable_helpers ],
  components: {
    GroupCard: () => import('./GroupCard.vue'),
  },
  data() {
    return {
      local_groups: [],
      loading: false
    }
  },
  methods: {
    reorder(e){;
      setTimeout(() => {
        if (!this.is_dragging){
          if (e.moved) {
            this.loading = true
            let obj = {
              id: this.one_flow.id,
              groups_attributes: [...this.local_groups.map(({id, position}, idx)=> {return {id, position: idx}})]
            }
            this.reorderGroups(obj).then(d => {
              // this.$emit('done')
            }).catch(err=> {
              console.log(err);
              if (err.response && err.response.data){
                err = err.response.data.errors
                // console.log({err});
              }
              this.addNotification({type: 'error', msg: `Erro: ${err}`})
            }).finally(()=>{
              this.loading = false
            })
          }
        }
      }, 500);
    },
    ...mapActions({
      reorderGroups: "ConfigFlow/reorderGroups",
      addNotification: 'Notification/add',
      // function: 'Module/action'
    })
  },
  computed: {
    ...mapState({
      groups: state => state.ConfigFlow.all_groups,
      one_flow: state => state.ConfigFlow.one_flow,
    })
  },
  mounted () {
    this.local_groups = [...this.groups];
  },
  watch: {
    'groups'(nv,ov) {
      if (nv){
        this.local_groups = [...this.groups];
      } else if (nv == false){
      }
    }, 
  },
}
</script>

<style scoped>

</style>